var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackLogoBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-4 -3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 33 0 33 33 0 33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    d: "M16.4861111,25.550603 L6.25,17.7383325 L4,19.4562139 L16.5,29 L29,19.4562139 L26.7361111,17.7246985 L16.4861111,25.550603 L16.4861111,25.550603 Z M16.5,22.0875721 L26.7222222,14.2753015 L29,12.5437861 L16.5,3 L4,12.5437861 L6.26388889,14.2753015 L16.5,22.0875721 L16.5,22.0875721 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackLogoBlue);
export default __webpack_public_path__ + "static/media/stack-logo-blue.3f97ddac44982f37111c70577b852f94.svg";
export { ForwardRef as ReactComponent };